import {Component, OnDestroy, OnInit} from "@angular/core";
import {HttpErrorResponse} from '@angular/common/http';
import {Subscription, switchMap, timer} from "rxjs";
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule} from "@angular/forms";
import {MailingService, Status} from "./mailing.service";
import {AlertService} from "../../common/alert/alert.service";
import {AlertComponent} from "../../common/alert/alert.component";

@Component({
    selector: 'mailing',
    templateUrl: './mailing.component.html',
    imports: [
        ReactiveFormsModule,
        FormsModule,
        AlertComponent,
    ],
    styleUrls: ['./mailing.component.css'],
    providers: [AlertService]
})
export class MailingComponent implements OnInit, OnDestroy {
    private formBuilder = new FormBuilder().nonNullable;
    private emailsFileName = this.formBuilder.control("");
    private templateId = this.formBuilder.control("");
    private campaign = this.formBuilder.control("");
    private subscriptions: Subscription[] = [];
    private isSending: boolean = false
    private status: Status = {
        message: '',
        inProgress: false
    };

    get isInProgress(): boolean {
        return this.isSending || this.status.inProgress
    }

    get message(): string {
        return this.status.message
    }

    form: FormGroup = new FormGroup({
        emailsFile: this.emailsFileName,
        templateId: this.templateId,
        campaign: this.campaign
    });

    constructor(private service: MailingService, private alertService: AlertService) {

    }

    ngOnInit() {
        this.subscriptions.push(
            timer(0, 1000)
                .pipe(
                    switchMap(() => this.service.getStatus()),
                )
                .subscribe({
                    next: (status) => {
                        this.status = status;
                    },
                    error: () => {
                        this.alertService.showAlert("danger", "Error loading status", null);
                    }
                })
        );
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    sendEmails() {
        this.alertService.clearAlerts();
        this.isSending = true
        this.service.sendEmails(this.emailsFileName.value, this.templateId.value, this.campaign.value)
            .subscribe({
                error: (result: HttpErrorResponse) => {
                    this.alertService.showAlert("danger", result.error, null);
                },
                complete: () => {
                    this.isSending = false
                }
            });
    }
}
